import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/core/auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login-celular',
  templateUrl: './login-celular.component.html',
  styleUrls: ['./login-celular.component.css']
})
export class LoginCelularComponent implements OnInit, OnDestroy {
  public hidePassword: boolean = true;
  public loginHash: string = '';
  public loginCode: string = '';
  public nrCelular: string = '';
  public nrCelularMasked: string = '';
  public isLoading: boolean = true;
  public hashInvalida: boolean = false;
  public loginSucesso: boolean = false;

  private passFormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(3)
  ]);

  public loginFormGroup = new FormGroup({
    pass: this.passFormControl
  });

  public errStr?: string;
  public subscription?: Subscription;

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.loginHash = this.activatedRoute.snapshot.queryParams['hash'] || '';
    this.loginCode = this.activatedRoute.snapshot.queryParams['code'] || '';
    
    if (!this.loginHash || !this.loginCode) {
      this.router.navigate(['/']);
      return;
    }

    this.validateHash();
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private validateHash(): void {
    this.httpClient
      .post<{ celular: string }>('/api/login/validateLoginHash', { 
        hash: this.loginHash,
        code: this.loginCode 
      })
      .subscribe({
        next: (response) => {
          this.nrCelular = response.celular;
          this.nrCelularMasked = this.maskCelularWithAsterisks(this.nrCelular);
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erro ao validar hash:', err);
          this.hashInvalida = true;
          this.isLoading = false;
        }
      });
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private maskCelular(celular: string): string {
    if (celular.length === 11) {
      return `(${celular.substring(0, 2)}) ${celular.substring(2, 7)}-${celular.substring(7)}`;
    } else if (celular.length === 10) {
      return `(${celular.substring(0, 2)}) ${celular.substring(2, 6)}-${celular.substring(6)}`;
    }
    return celular;
  }

  private maskCelularWithAsterisks(celular: string): string {
    if (celular.length === 11) {
      // Formato: +** (**) *****-4215
      const last4 = celular.substring(7);
      return `+** (**) *****-${last4}`;
    } else if (celular.length === 10) {
      // Formato: +** (**) ****-4215
      const last4 = celular.substring(6);
      return `+** (**) ****-${last4}`;
    }
    return `***-${celular.substring(Math.max(0, celular.length - 4))}`;
  }

  private onLoginError(err: any) {
    console.error(`Login error: ${JSON.stringify(err)}`);

    if (err.status === 401 || err.status === 400) {
      if (err.error?.message === 'Link inválido ou expirado') {
        this.errStr = 'Este link já foi utilizado ou expirou. Solicite um novo link.';
      } else {
        this.errStr = 'Senha incorreta.';
      }
    } else if (err.status === 0) {
      this.errStr = 'Não foi possível conectar ao servidor.';
    } else if (err.status === 403) {
      this.errStr =
        'Usuário não autorizado.';
    } else {
      this.errStr = err.error?.message || 'Erro ao realizar login.';
    }
  }

  public onLogin() {
    this.unsubscribe();
    const pass: string = this.passFormControl.value!.toString();
    this.passFormControl.setValue("");
    this.passFormControl.markAsUntouched();
    this.errStr = undefined;
    
    this.subscription = this.httpClient
      .post('/api/login/authenticateByCelular', {
        hash: this.loginHash,
        pass: pass
      })
      .subscribe({
        next: () => {
          this.unsubscribe();
          this.loginSucesso = true;
        },
        error: (err) => {
          this.unsubscribe();
          this.onLoginError(err);
        },
      });
  }

  public togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  public redirectToSistemas() {
    window.location.href = environment.sistemasUrl;
  }

  public backToHome() {
    this.router.navigate(['/']);
  }
}
